export const provinceFullNameById = {
  BC: "British Columbia",
  SK: "Saskatchewan",
  MB: "Manitoba",
  AB: "Alberta",
  NT: "Northwest Territories",
  NS: "Nova Scotia",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  PEI: "Prince Edward Island",
  ON: "Ontario",
  QC: "Quebec",
  YT: "Yukon",
  NU: "Nunavut",
} as const;

export const provinceIdByFullName = Object.fromEntries(
  Object.entries(provinceFullNameById).map(([key, value]) => [value, key]),
) as {
  [K in (typeof provinceFullNameById)[keyof typeof provinceFullNameById]]: keyof typeof provinceFullNameById;
};

export type Province = keyof typeof provinceFullNameById;
export type ProvinceFull = (typeof provinceFullNameById)[Province];
